import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { colors5, colorsG } from '../../../../constants/icons/characteristics/Characteristics';

import './styles.css';
import DoughnutDB from '../../../graphics/containers/DoughnutDB';
import MatrixDB from '../../../graphics/containers/MatrixDB';
import AreaDB from './../../../graphics/containers/AreaDB';
import NegativeDB from './../../../graphics/containers/NegativeDB';
import TopDB from './../../../graphics/containers/TopDB';
import BarsDB from './../../../graphics/containers/CleanBarDB';
import LineDB from './../../../graphics/containers/LineDB';
import TotalDB from '../../../graphics/containers/TotalDB';



export default class GraphicsContainer extends Component {
  handleDoughut = (graphicName) => {
    if (typeof graphicName === "undefined" || graphicName === null) {
      return (<div></div>);
    }
    return graphicName.filter((val) => {
      return (val.dataSet.length > 0)
    }).map((val, index) => {
      return (
        <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6} key={'grid-container-' + index}>
          <DoughnutDB
            name={val.name}
            title={val.title}
            data={val.dataSet}
            date={val.date}
            colors={val.title === 'Género' ? colorsG : colors5}
            openDialog={this.props.openDialog}
            onClickGraphic={this.props.onClickGraphic}
          />
        </Grid>
      )
    });
  }

  handleMatrix = (graphicName) => {
    if (typeof graphicName === "undefined" || graphicName === null) {
      return (<div></div>);
    }
    return graphicName.filter((val) => {
      return (val.dataSet.length > 0)
    }).map((val, index) => {
      return (
        <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6} key={'grid-matrix-' + index}>
          <MatrixDB
            name={val.name}
            title={val.title}
            data={this.GetDataMatrix(val.dataSet)}
            openDialog={this.props.openDialog}
            onClickGraphic={this.props.onClickGraphic}
            seeMore={false}
          />
        </Grid>

      )
    });
  }

  handleArea = (graphicName) => {
    if (typeof graphicName === "undefined" || graphicName === null) {
      return (<div></div>);
    }
    let total = graphicName.reduce((tot, cv) => (tot + cv));
    if (total === 0) {
      return (<div></div>);
    }
    return (
      <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6}>
        <AreaDB
          name={'area'}
          title={'Edad'}
          data={graphicName}
          openDialog={this.props.openDialog}
          onClickGraphic={this.props.onClickGraphic}
          seeMore={false}
        />
      </Grid>
    )
  }
  handleNegative = (graphicName) => {
    if (typeof graphicName === "undefined" || graphicName === null) {
      return (<div></div>);
    }
    if (graphicName.length === 0 || graphicName === null) {
      return (<div></div>);
    }
    return (
      <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6}>
        <NegativeDB
          name={'negativo'}
          title={'Horas'}
          data={graphicName}
          openDialog={this.props.openDialog}
          onClickGraphic={this.props.onClickGraphic}
          seeMore={false}
        />
      </Grid>
    )
  }

  handleTop = (graphicName) => {
    if (typeof graphicName === "undefined" || graphicName === null) {
      return (<div></div>);
    }
    // if (typeof graphicName.data.dataSetTop5 === "undefined" || graphicName === null) {
    //     return (<div></div>);
    // }
    return graphicName.filter((val) => {
      return (val.dataSet.length > 0)
    }).map((val, index) => {
      return (
        <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6} key={'grid-top-' + index}>
          <TopDB
            name={val.name}
            title={val.title}
            data={val.dataSet}
            openDialog={this.props.openDialog}
            onClickGraphic={this.props.onClickGraphic}
            seeMore={false}
            seeTen={true}
          />
        </Grid>
      )
    });
  }

  handleLine = (graphicName) => {
    if (typeof graphicName === "undefined" || graphicName === null) {
      return (<div></div>);
    }
    return graphicName.filter((val) => {
      return (val.dataSet.length > 0)
    }).map((val, index) => {
      return (
        // <Grid className='chartColList' item xs={12} lg={12} key={'grid-line-' + index}>
        <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6} key={'grid-line-' + index}>
          <LineDB
            name={val.name}
            title={val.title}
            data={val.dataSet}
            date={val.date}
            openDialog={this.props.openDialog}
            onClickGraphic={this.props.onClickDate}
            seeMore={true}
          />
        </Grid>
      )
    });
  }

  GetDataMatrix = (horas) => {
    let dias = [];
    if (horas.length < 7) {
      for (let i = 0; i < horas.length; i++) {
        let valor = {
          horas: horas[i],
          dia: ''
        }
        switch (i) {
          case 0: valor.dia = 'M'; break;
          case 1: valor.dia = 'M'; break;
          case 2: valor.dia = 'T'; break;
          default: valor.dia = 'N'; break;
        }
        dias.push(valor);
      }
    } else {
      for (let i = 0; i < horas.length; i++) {
        let valor = {
          horas: horas[i],
          dia: ''
        }
        switch (i) {
          case 0: valor.dia = 'L'; break;
          case 1: valor.dia = 'M'; break;
          case 2: valor.dia = 'M'; break;
          case 3: valor.dia = 'J'; break;
          case 4: valor.dia = 'V'; break;
          case 5: valor.dia = 'S'; break;
          default: valor.dia = 'D'; break;
        }
        dias.push(valor);
      }
    }

    return dias;
  }

  handleBar = (graphicName) => {
    if (typeof graphicName === "undefined" || graphicName === null) {
      return (<div></div>);
    }
    return graphicName.filter((val) => {
      return (val.dataSet.length > 0)
    }).map((val, index) => {
      return (
        <Grid className='chartColList' item xs={12} lg={12} key={'grid-barmp-' + index}>
          <BarsDB
            name={val.name}
            title={val.title}
            data={val.dataSet}
            date={val.date}
            openDialog={this.props.openDialog}
            onClickGraphic={this.props.onClickGraphic}
            seeMore={false}
            seeRate={true}
          />
        </Grid>
      )
    });
  }

  middle = (a, b, c) => {
    console.log(a,b,c)
    // this.props.onClickGraphic(a,b,c)
  }

  handleTotal = (data, index) => {
    return (
      <React.Fragment key={`plot-total-${index}`}>
        {
          data.map((d, i) =>
            <Grid className='chartColList' item xs={12} lg={(this.props.anchoMap) ? 12 : 6} key={`plot-single-total-${index}`}>
              <TotalDB
                name={d.name}
                title={d.title}
                data={d}
                colors={colors5[index % colors5.length]}
                openDialog={this.props.openDialog}
                onClickGraphic={this.middle}
                seeMore={false}
              />
            </Grid>
          )
        }
      </React.Fragment>
    )
  }

  handleMapTotal = (vector) => {
    return vector.map((item, i) => this.handleTotal(item, i))
  }

  handleMapDoughut = (vector) => {
    return vector.map(item => this.handleDoughut(item))
  }

  handleMapLine = (vector) => {
    return vector.map(item => this.handleLine(item))
  }

  handleMapMatrix = (vector) => {
    return vector.map(item => this.handleMatrix(item))
  }

  handleMapTop = (vector) => {
    return vector.map(item => this.handleTop(item))
  }


  render() {
    return (
      <Grid container>
        {
          this.handleMapTotal(this.props.totales)
        }
        {
          this.handleBar(this.props.topcomuna)
        }
        {
          this.handleMapLine(this.props.lineas)
        }
        {
          this.handleMapDoughut(this.props.donas)
        }
        {
          this.handleMapTop(this.props.tops)
        }
        {
          this.handleMapMatrix(this.props.matrices)
        }
        {
          this.handleArea(this.props.timeEdadResult)
        }
        {
          this.handleNegative(this.props.timeHorasResult)
        }
      </Grid>

    )
  }
}
